import { render, staticRenderFns } from "./RecommenHighlightItem.vue?vue&type=template&id=2378f13a&scoped=true&"
import script from "./RecommenHighlightItem.vue?vue&type=script&lang=js&"
export * from "./RecommenHighlightItem.vue?vue&type=script&lang=js&"
import style0 from "./RecommenHighlightItem.vue?vue&type=style&index=0&id=2378f13a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2378f13a",
  null
  
)

export default component.exports